import { Text as PomodoroText } from "@app/domains/shared/design-system";
import styled from "styled-components";

export const Text = styled(PomodoroText)`
  font-size: ${({ theme }) => theme.fontSizes.xs} !important;
  line-height: ${({ theme }) => theme.fontSizes.s};
  color: ${({ theme }) => theme.colors.black};
`;
